export function error(message) {
  const key = 'error'
  const icon = 'error_outline'
  if (message && message.length > 0) {
    return window.Materialize.toast(`${message} <i class="material-icons flash-icon flash-icon-${key}">${icon}</i>`, 5000)
  }
}

export function info(message) {
  const key = 'info'
  const icon = 'info'
  if (message && message.length > 0) {
    return window.Materialize.toast(`${message} <i class="material-icons flash-icon flash-icon-${key}">${icon}</i>`, 5000)
  }
}

export function success(message) {
  const key = 'success'
  const icon = 'check_circle'
  if (message && message.length > 0) {
    return window.Materialize.toast(`${message} <i class="material-icons flash-icon flash-icon-${key}">${icon}</i>`, 5000)
  }
}



// WEBPACK FOOTER //
// ./src/flash-messages.js